<template>
  <v-container
    id="register"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                <v-icon left>
                  mdi-view-dashboard
                </v-icon>
                Tableau de bord Happy Quest
                <v-icon right>
                  mdi-view-dashboard
                </v-icon>
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-bold">
              Nouveau mot de passe
            </div>

            <v-row>
              <card-alert
                :msg="msg"
                :icon="icon"
                :color="color"
              />
            </v-row>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import CardAlert from '../dashboard/alerts/CardAlert.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'RedirectionNewPassword',

    /* Sous-composants utilisés par ce composant */
    components: {
      CardAlert,
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        msg: 'Bravo ! Tu peux maintenant retourner te connecter avec ton nouveau mot de passe.',
        icon: 'mdi-checkbox-marked-circle-outline',
        color: 'success',
      }
    },
  }
</script>
